export const getNavItems = (user, shouldShowItem) => [
  {
    id: "about",
    path: "about-page",
    label: "About Us",
  },
  {
    id: "whatWeDo",
    path: "what-we-do",
    label: "What We Do",
  },
  {
    id: "film",
    path: "film-list-page",
    label: "Film Production",
  },
  {
    id: "outlets",
    path: "our-outlets-page",
    label: "Our Outlets",
  },
  {
    id: "contact",
    path: "contact-page",
    label: "Contact",
  },
  {
    id: "control-panel",
    path: "/control-panel/client-dashboard",
    label: "Control Panel",
    show: user?.role === "admin" || user?.role === "superAdmin",
  },
  {
    id: "my-outlet",
    label: "My Outlet",
    path:"/my-portal",
    dropdown: true,
    show: user?.role === "client" && shouldShowItem("my-outlet"),
    items: [
      { path: "/my-portal", label: "Dashboard" },
      { path: "/my-portal/settings", label: "Settings" },
    ],
  },
];
